import React from "react";
import { MenuItem, Select } from "@mui/material";
import _ from "lodash";
import { useCurrentEditor } from "@tiptap/react";

type AddPlaceHolderProps = {
  placeholders: Record<string, string>;
  productClassName: string;
};

const AddPlaceholder = ({ placeholders, productClassName }: AddPlaceHolderProps) => {
  const { editor } = useCurrentEditor();

  if (!editor) {
    return null;
  }
  const addPlaceholder = (placeholder: string) => {
    editor?.commands.insertContent(placeholder);
  };

  return (
    <Select value={"static"} variant="standard" disableUnderline={true}>
      <MenuItem value={"static"} disabled>
        Wert einfügen
      </MenuItem>
      <MenuItem onClick={() => addPlaceholder("<%= salutation(product, formValues) %>")}>Grußform</MenuItem>
      <MenuItem onClick={() => addPlaceholder('<%= translate(product, "calendlyLinkRoundRobin") %>')}>
        Terminlink nach Rechtsprodukt
      </MenuItem>
      <MenuItem onClick={() => addPlaceholder('<%= translate(product, "calendlyLinkLawyer") %>')}>
        Terminlink nach Anwalt
      </MenuItem>
      <MenuItem
        onClick={() =>
          addPlaceholder('<%= wrapInLinkTag("https://legalbird.io" + getCaseLink(product, "/extern"), "Zum Fall") %>')
        }
      >
        Link externer Fall
      </MenuItem>
      <MenuItem
        onClick={() => addPlaceholder('<%= wrapInLinkTag(getServiceWorldCaseLink(product), "Zu meinem Fall") %>')}
      >
        Link "Zu meinem Fall"
      </MenuItem>
      <MenuItem
        onClick={() =>
          addPlaceholder('<%= wrapInLinkTag(getServiceWorldCaseMessagingLink(product), "Nachricht schreiben") %>')
        }
      >
        Nachricht schreiben pro Fall
      </MenuItem>
      <MenuItem
        onClick={() =>
          addPlaceholder('<%= wrapInLinkTag(getServiceWorldCaseLink(product, "status"), "Angaben vervollständigen") %>')
        }
      >
        Angaben vervollständigen pro Fall
      </MenuItem>
      <MenuItem onClick={() => addPlaceholder("<%= getWeRepresentAllClients(product) %>")}>
        Vertretung rechtlicher Interessen
      </MenuItem>
      {productClassName === "contractLaw" && (
        <MenuItem onClick={() => addPlaceholder('<%= translate(product, "referenceRecipient", formValues) %>')}>
          Aktenzeichen Empfänger
        </MenuItem>
      )}
      <MenuItem onClick={() => addPlaceholder('<%= translate(product, "genderedResponsibleLawyer") %>')}>
        Rechtsanwalt/Rechtsanwältin [Name]
      </MenuItem>
      {/* TODO if this gets bigger, extract into extensionfile and access via productclassname*/}
      {productClassName === "traffic" && (
        <MenuItem onClick={() => addPlaceholder('<%= translate(product, "appealRevokeLink") %>')}>
          Link Einspruchsrücknahme
        </MenuItem>
      )}
      {productClassName === "contractLaw" && (
        <MenuItem onClick={() => addPlaceholder('<%= translate(product, "furtherProcessLink") %>')}>
          Link Rückmeldung weiteres Vorgehen
        </MenuItem>
      )}
      {productClassName === "trafficAccident" && (
        <MenuItem
          onClick={() => addPlaceholder('In dem Rechtsstreit\n<%= translate(product, "rubrumTrafficAccident") %>')}
        >
          Rubrum - Gerichtliches Verfahren
        </MenuItem>
      )}
      {["contractLaw", "generalCivilLaw", "employmentContract", "rentalContract", "civilServiceLaw"].includes(
        productClassName
      ) && (
        <MenuItem
          onClick={() => addPlaceholder('In dem Rechtsstreit\n<%= translate(product, "rubrumLitigationCase") %>')}
        >
          Rubrum - Gerichtliches Verfahren
        </MenuItem>
      )}
      {_.map(placeholders, (label, path) => (
        <MenuItem
          key={path}
          value={path}
          onClick={() => addPlaceholder(`<%= translate(product, "${path.substring(0, path.indexOf(".label"))}") %>`)}
        >
          {label} ({path.substring(0, path.indexOf(".label"))})
        </MenuItem>
      ))}
    </Select>
  );
};

export default AddPlaceholder;
